export default __webpack_public_path__ + "static/media/diploma-metafisica-salud.fd8ac942.jpeg";